<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "ventas/view_venta?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          // console.log(response);
          this.formPro.totalPendiente = response.data.orden.saldo_credito_v
            this.formPro.totalPagado = (parseFloat(response.data.orden.total_v) - parseFloat(response.data.orden.saldo_credito_v));
          this.estadoCredito=response.data.orden.estado_credito_v;
          this.formFactura.datCert = response.data.orden.dataCert;
          this.formFactura.serie = response.data.orden.serie;
          this.formFactura.number = response.data.orden.number;
          this.formFactura.uuid = response.data.orden.uuid;
          if (response.data.orden.nit_facturacion != "CF") {
            this.formPro.cliente = response.data.orden.nit_facturacion
              ? response.data.orden.nombre_cliente
              : response.data.orden.cliente.persona.nombre_persona;
            this.formPro.direccionp =
              response.data.orden.cliente.persona.direccion_persona == ""
                ? "Ciudad"
                : response.data.orden.cliente.persona.direccion_persona;
            this.formPro.nit_cliente = response.data.orden.nit_facturacion
              ? response.data.orden.nit_facturacion
              : "CF";
          } else {
            this.formPro.cliente = response.data.orden.nombre_cliente;
            this.formPro.direccionp =
              response.data.orden.cliente.persona.direccion_persona != ""
                ? response.data.orden.cliente.persona.direccion_persona
                : "Ciudad";
            this.formPro.nit_cliente = "CF";
          }
          this.formPro.vendedor =
            response.data.orden.user.empleado.persona.nombre_persona ;
          this.formPro.total =
            response.data.orden.estado_cuenta == true
              ? parseFloat(response.data.orden.total_v) +
                parseFloat(response.data.orden.pago_cuenta)
              : response.data.orden.total_v;
          this.formPro.no_orden = response.data.orden.no_venta;
          let detalleProducto = response.data.orden.detalle_ventas;
          let detalleServicio = response.data.orden.detalle_servicio_vs;
          // console.log(detalleProducto, detalleServicio);
          if (detalleProducto) {
            for (let i = 0; i < detalleProducto.length; i++) {
              me.detalleorden.push({
                cantidad: detalleProducto[i].cantidad_venta,
                descripcion:
                  detalleProducto[i].producto.nombre_producto +
                  (detalleProducto[i].producto.descripcion_producto ==
                    null ||
                  detalleProducto[i].producto.descripcion_producto == ""
                    ? ""
                    : " - " +
                      detalleProducto[i].producto.descripcion_producto),
                valor_unitario: detalleProducto[i].precio_venta,
                subtotal: detalleProducto[i].subtotal_venta,
              });
            }
          }

          if (detalleServicio) {
            for (let i = 0; i < detalleServicio.length; i++) {
              me.detalleorden.push({
                cantidad: detalleServicio[i].cantidad_servicios,
                descripcion:
                  detalleServicio[i].servicio.nombre_servicio +
                  (detalleServicio[i].servicio.descripcion_servicio == "" ||
                  detalleServicio[i].servicio.descripcion_servicio == null
                    ? ""
                    : " - " + detalleServicio[i].servicio.descripcion_servicio),
                valor_unitario: detalleServicio[i].precio_servicio,
                subtotal: detalleServicio[i].subtotal_servicio,
              });
            }
          }
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />

    <!-- Botones -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'ventas' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Documento -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body doc">
            <!-- Header corporativo -->
            <div class="doc-header">
              <div class="doc-brand">
                <img :src="logoUrl" alt="Logo" class="doc-logo" />
                <div>
                  <div class="doc-name">Repuestos Ariel GT</div>
                  <div class="doc-tag">Sociedad Anónima · NIT 234234234-5</div>
                  <div class="doc-tag">Comapa, Jutiapa · Tel 4889 9653 / 4477 4533</div>
                </div>
              </div>
              <div class="doc-meta">
                <div class="doc-badge" v-if="formFactura.serie">FACTURA FEL</div>
                <div class="doc-badge" v-else>RECIBO</div>
                <div v-if="estadoCredito" class="doc-credit">VENTA AL CRÉDITO</div>
              </div>
            </div>

            <!-- Datos FEL -->
            <div class="doc-fel" v-if="formFactura.serie">
              <div><span>Serie</span><b>{{ formFactura.serie }}</b></div>
              <div><span>Número</span><b>{{ formFactura.number }}</b></div>
              <div><span>Autorización</span><b>{{ formFactura.uuid }}</b></div>
            </div>

            <!-- Meta -->
            <div class="doc-grid">
              <div class="doc-box">
                <div class="doc-box-title" v-if="formFactura.serie">Dirección de facturación</div>
                <div class="doc-box-title" v-else>Cliente</div>
                <div class="doc-box-name">{{ formPro.cliente }}</div>
                <div class="doc-box-line" v-if="formFactura.serie"><span>NIT:</span> {{ formPro.nit_cliente }}</div>
                <div class="doc-box-line"><span>Dirección:</span> {{ formPro.direccionp }}</div>
              </div>
              <div class="doc-box">
                <div class="doc-box-line"><span>Fecha emisión:</span> {{ showDate(new Date()) }}</div>
                <div class="doc-box-line" v-if="formFactura.serie"><span>Fecha certificación:</span> {{ showDate(new Date()) }}</div>
                <div class="doc-box-line"><span>Vendedor:</span> {{ formPro.vendedor }}</div>
                <div class="doc-box-line" v-if="formFactura.serie"><span>Fecha vencimiento:</span> {{ showDate(new Date()) }}</div>
              </div>
            </div>

            <table class="doc-table">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th class="c">Cantidad</th>
                  <th class="r">Precio unitario</th>
                  <th class="r">Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detalleorden" v-bind:key="idx">
                  <td>{{ item.descripcion }}</td>
                  <td class="c">{{ quantity(item.cantidad) }} Unidad(es)</td>
                  <td class="r">{{ money(item.valor_unitario) }}</td>
                  <td class="r">{{ money(item.subtotal) }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Totales -->
            <div class="doc-totals">
              <div class="doc-totline">
                <span>Total</span>
                <strong>{{ money(formPro.total > 0 ? formPro.total : 0.0) }}</strong>
              </div>
              <div class="doc-totline doc-pendiente" v-if="estadoCredito">
                <span>Pendiente</span>
                <strong>{{ money(formPro.totalPendiente) }}</strong>
              </div>
              <div class="doc-totline" v-if="estadoCredito">
                <span>Adelanto</span>
                <strong>{{ money(formPro.totalPagado) }}</strong>
              </div>
            </div>

            <div class="doc-letras">
              <strong>Valor en letras:</strong> {{ letras(formPro.total) }}
            </div>

            <p class="doc-nota">
              <strong>IMPORTANTE:</strong> Apreciable cliente, en repuestos no se aceptan
              cambios ni devoluciones. Para cambios y devoluciones de otros artículos el
              plazo es de 3 días hábiles; deberá presentar su factura o comprobante de
              compra y el producto debe encontrarse en las mismas condiciones en que fue
              entregado.
            </p>

            <div class="doc-footer">Repuestos Ariel GT · Comapa, Jutiapa</div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.doc { color: #2b2f3a; font-size: 13px; }

.doc-header {
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 4px solid #1b2a4e; padding-bottom: 16px; margin-bottom: 16px;
}
.doc-brand { display: flex; align-items: center; gap: 16px; }
.doc-logo { height: 76px; width: auto; object-fit: contain; border-radius: 8px; }
.doc-name { font-size: 23px; font-weight: 800; color: #1b2a4e; }
.doc-tag { font-size: 12px; color: #6b7280; }
.doc-meta { text-align: right; }
.doc-badge {
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 14px;
  padding: 6px 16px; border-radius: 4px; letter-spacing: 1px; display: inline-block;
}
.doc-credit {
  display: inline-block; margin-top: 6px; background: #c0392b; color: #fff;
  font-weight: 700; font-size: 11px; padding: 2px 10px; border-radius: 3px;
}

.doc-fel {
  display: flex; gap: 16px; background: #f7f9fc; border: 1px solid #e7e9ef;
  border-radius: 8px; padding: 10px 16px; margin-bottom: 14px;
}
.doc-fel div { display: flex; flex-direction: column; }
.doc-fel span { font-size: 10px; color: #8a909c; text-transform: uppercase; }
.doc-fel b { font-size: 12px; color: #1b2a4e; }

.doc-grid { display: flex; gap: 14px; margin-bottom: 16px; }
.doc-box {
  flex: 1; background: #f7f9fc; border: 1px solid #e7e9ef;
  border-radius: 8px; padding: 12px 16px;
}
.doc-box-title { font-size: 10px; color: #8a909c; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 4px; }
.doc-box-name { font-size: 15px; font-weight: 700; color: #1b2a4e; }
.doc-box-line { font-size: 12px; color: #4b5563; margin-top: 2px; }
.doc-box-line span { color: #8a909c; }

.doc-table { width: 100%; border-collapse: collapse; }
.doc-table thead th {
  background: #1b2a4e; color: #fff; font-size: 11px; font-weight: 600;
  text-transform: uppercase; padding: 9px 10px; text-align: left;
}
.doc-table tbody td { padding: 8px 10px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
.doc-table tbody tr:nth-child(even) { background: #f9fafc; }
.doc-table .r { text-align: right; }
.doc-table .c { text-align: center; }

.doc-totals {
  margin-left: auto; width: 320px; margin-top: 14px;
  border: 1px solid #e7e9ef; border-radius: 8px; overflow: hidden;
}
.doc-totline {
  display: flex; justify-content: space-between; align-items: center;
  padding: 8px 14px; font-size: 13px; border-bottom: 1px solid #eef0f4;
}
.doc-totline:last-child { border-bottom: 0; }
.doc-totline strong { font-size: 15px; color: #1b2a4e; }
.doc-pendiente { background: #fff6f4; }
.doc-pendiente span, .doc-pendiente strong { color: #c0392b; }

.doc-letras { margin-top: 16px; font-size: 13px; }
.doc-nota {
  margin-top: 10px; font-size: 11px; color: #6b7280; text-align: justify;
  background: #f7f9fc; border-left: 3px solid #c5a253; padding: 10px 12px; border-radius: 4px;
}
.doc-footer {
  margin-top: 22px; text-align: center; color: #8a909c; font-size: 11px;
  border-top: 1px solid #e7e9ef; padding-top: 10px;
}

@media print {
  .doc, .doc * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
